// extracted by mini-css-extract-plugin
module.exports = {"table":"IssueVxeTable_table_1fHlv","dueDate":"IssueVxeTable_dueDate_sdgOn","groupTitle":"IssueVxeTable_groupTitle_qxiFS"};